
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const SET_SURVEY = "setSurvey";
export const SET_PARTNER_SERVICE_LIST = "setPartnerServiceList";
export const SET_CREATED_OBJECT = "ceatepartner";
// export const SET_CATEGORY = "setCategory";
export const SET_CREATE_CATEGORY = "setCreatedCategory";
export const SET_DELETED_PARTNER = "setDeletedPartner";
export const SET_SERVICE = "setService";
export const SET_CREATE_SERVICE = "setCreatedService";
export const SET_USER = "setUser";
export const SET_CREATE_USER = "setCreatedUser";

export const SET_PARTNER = "setPartner";
export const SET_CREATE_PARTNER = "setCreatedPartner";

export const SET_PARTNER_MASTER = "setPartnerMasterList";
export const SET_SERVICE_CATEGORY_MASTER = "setServiceCategoryMaster";
export const SET_USER_LIST = "setUserList";
export const SET_PARTNER_LIST = "setPartnerList";

export const CLEAR_VUEX = "clearVuex";
export const SET_ADMIN_LIST = "setAdminList";
export const SET_QUESTIONNARIE_LIST = "setQurstionnarieList";
export const SET_PARTNER_USER_LIST = "setPartnerUserList";

export const SET_PARTNER_PATIENT_LIST = "setPartnerPatientList";
export const SET_PATIENT_LIST = "setPatientList"
export const SET_PERMISSION_MENU = "setMenuList"

export const SET_UPDATE_PARTNERNAME = "setUpdatePartnerName"
export const SET_NOTIFICATION_LIST = "setNotificationList"
export const SET_PARTNER_NOTIFICATION_LIST = "setPartnerNotification"

/* Branch */
export const SET_PARTNER_STORES = "setPartnerStores"
export const SET_PARTNER_BRNACH_LIST = "setPartnerBranchList"
export const SET_NOTIFICATION_COUNT = "setNotificationCount"

